export const DYNAMIC_PAGES_CONTAINER = {
  ALIAS_NAMES: {
    about: 'about',
    privacy: 'privacy',
    publishers: 'publishers',
    advertise: 'advertise',
    jobs: 'jobs',
    contact: 'contact',
    terms: 'terms',
   deleteAccount: 'delete-account',
  }
}
